import style from './list-of-provinces.module.css'

import clsx from 'clsx'

import { Shimmer } from '@wartek-id/shimmer'

import { range } from '@/utils/array'
import {
  DataIndukVariant,
  PtkStatsByParentWilayahResponseDataWithImage,
  SatpenStatsByParentWilayahResponseDataWithImage,
  YayasanStatsByParentWilayahResponseData,
} from '@/apis/types'

import { DATA_INDUK_ROUTE } from '@/configs/constants'

import { ProvinceLogoCard } from './ProvinceLogoCard'

export const ListOfProvinces = ({
  isPending,
  provinceId,
  provinces,
  additionalParams,
  prefixPath = DATA_INDUK_ROUTE,
  variant = 'satuan-pendidikan',
}: {
  provinceId?: string
  isPending: boolean
  provinces:
    | SatpenStatsByParentWilayahResponseDataWithImage[]
    | YayasanStatsByParentWilayahResponseData[]
    | PtkStatsByParentWilayahResponseDataWithImage[]
  additionalParams: string
  prefixPath?: string
  variant?: DataIndukVariant
}) => {
  return (
    <div
      className={clsx(
        'min-h-[500px] w-full columns-1 gap-4 rounded-lg border bg-gray-5 p-2 md:columns-2 md:p-4 lg:columns-3',
        style.logoProvinceWrapper
      )}
      data-testid="list-of-provinces"
    >
      {!isPending ? (
        <>
          {provinces.map((province, indexRow) => (
            <ProvinceLogoCard
              provinceId={provinceId}
              key={province.district.kodeWilayah}
              district={province.district}
              image={province?.image}
              stats={
                province.satuanPendidikanStatistics ||
                province.yayasanPendidikanStatistics ||
                province.ptkStatistics
              }
              additionalParams={additionalParams}
              index={indexRow + 1}
              prefixPath={prefixPath}
              variant={variant}
            />
          ))}
        </>
      ) : (
        <>
          {range(1, 13)?.map((indexRow) => (
            <Shimmer
              width={200}
              height={50}
              key={indexRow}
              className="mb-2 !w-full"
            />
          ))}
        </>
      )}
    </div>
  )
}
